import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy, memo } from 'react';

const LazyStudentCalender = lazy(() =>
  import('./studentCalender')
    .then((module) => ({ default: module.StudentCalender }))
    .catch(() => {
      document.location.reload();
      return { default: memo(() => <></>) };
    })
);

export const StudentCalender = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyStudentCalender />
  </Suspense>
);
